import {
    SET_PLACES,
    SET_EDIT_PLACE,
    SET_NEW_PLACE,
    SET_DELETE_PLACE,
    SET_DELETE_MULTI_PLACE,
    SET_LIST_PLACES,
    SET_PLACE,
    RESET_ITEMS_PLACE,
    RESET_LIST_PLACES,
    RESET_SELECTED_PLACE,
} from "redux/constants/Places";

const initalAgreementState = {
    items: [],
    list: [],
    selected: {},
    loading: true,
};
const Places = (state = initalAgreementState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_PLACES: {
            return { ...state, items: payload, loading: false };
        }
        case SET_LIST_PLACES: {
            return { ...state, list: payload };
        }
        case SET_PLACE: {
            return { ...state, selected: payload };
        }
        case SET_NEW_PLACE: {
            return { ...state, items: [payload, ...state.items] };
        }

        case SET_EDIT_PLACE: {
            let list = [...state.items];

            try {
                let ind = list.findIndex((item) => item.id === payload.id);

                if (ind > -1) {
                    list[ind] = payload;
                }
            } catch (error) {}

            return { ...state, items: list };
        }

        case SET_DELETE_PLACE: {
            let list = state.items.filter((item) => item._id !== payload);

            return { ...state, items: list };
        }

        case SET_DELETE_MULTI_PLACE: {
            let arr = payload.split(",");
            let list = state.items.filter((item) => !arr.includes(item._id));

            return { ...state, items: list };
        }

        case RESET_ITEMS_PLACE: {
            return { ...state, items: [], loading: true };
        }
        case RESET_SELECTED_PLACE: {
            return { ...state, selected: {}, loading: true };
        }
        case RESET_LIST_PLACES: {
            return { ...state, list: [], loading: true };
        }

        default:
            return state;
    }
};

export default Places;
